import React, { useState } from "react";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';


export default function AddPromptModal({ isOpen, onClose, onSubmit }) {
    const [form, setForm] = useState({ name: "", content: "" });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" });
    };


    const handleEditorChange = (content) => {
        setForm({ ...form, content });
        if (errors.content) {
            setErrors({
                ...errors,
                content: ''
            });
        }
    }


    const handleSubmit = async () => {
        const validationErrors = {};
        if (!form.name.trim()) validationErrors.name = "Name is required";
        if (form.content.length === 11) validationErrors.content = "Content is required"; //for some weird reason..reatquill has a default value of 11 characters when the textarea is empty 

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setIsSubmitting(true);
        try {
            await onSubmit(form);
            onClose(); // Close modal on success
        } catch (error) {
            console.error("Submit failed:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-[80%] max-h-[70vh] lg:max-w-[50%]  overflow-y-auto shadow-lg">
                <h2 className="text-xl font-semibold mb-4">Add Prompt</h2>

                <div className="mb-4">
                    <label className="block text-sm font-medium">Name</label>
                    <select
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                        className="w-full mt-1 p-2 border border-gray-300 rounded"
                    >
                        <option value="">Select a Model</option>
                        <option value="angel">Angel</option>
                        <option value="alfred">Alfred</option>
                        <option value="anita">Anita</option>
                    </select>
                    {errors.name && <p className="text-red-500 text-sm">{errors.name}</p>}
                </div>

                <div className="mb-6">
                    <label htmlFor="content" className="block text-sm text-gray-700 mb-1">
                        Content
                    </label>
                    <div className={`${errors.content ? 'border border-red-500 rounded-md' : ''}`}>
                        <ReactQuill value={form.content} onChange={handleEditorChange} className="mb-4" />
                    </div>
                    {errors.content && (
                        <p className="mt-1 text-sm text-red-600 font-normal">{errors.content}</p>
                    )}
                    <p className="mt-2 text-xs text-gray-500">
                        Use the formatting toolbar to style your content.
                    </p>
                </div>

                <div className="flex justify-end space-x-3">
                    <button
                        className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
                        onClick={onClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 bg-brandPrimary text-white rounded"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                </div>
            </div>
        </div>
    );
}
